import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { Button } from "cxa-components";
import { isExist, compose } from "cxa-utils";
import { validateForm } from "./validation";
import { renderField } from "./components";
import { AXA_FORMS, SUBMIT_FAILURE_MESSAGE } from "../constants";
import enhance from "../hoc";

const AXA_HDF_ID = "axaHdf";

const AxaHdf = props => {
  const {
    handleSubmit,
    submitting,
    confirm,
    axaForm,
    hdfId,
    isReadOnly,
    renderValue,
    onSave,
    onPrint,
    onClose,
    employeeParticulars,
  } = props;
  const UwForm = AXA_FORMS[hdfId];
  const isSubmitFailed = isExist(axaForm) && axaForm.submitFailed;
  const handleSave = onSave(AXA_HDF_ID);

  return (
    <form>
      <Field component={renderField} type="hidden" name="HDFormID" />
      <UwForm
        isReadOnly={isReadOnly}
        renderValue={renderValue}
        employeeParticulars={employeeParticulars}
        formId={hdfId}
        values={axaForm && axaForm.values}
      />

      {isSubmitFailed && (
        <p role="alert" className="card--alert">
          {SUBMIT_FAILURE_MESSAGE}
        </p>
      )}

      <div style={{ padding: "10px" }}>
        {!isReadOnly ? (
          [
            <Button key="save" onClick={handleSave} disabled={submitting} secondary>
              Save
            </Button>,
            <Button
              key="submit"
              submitting={submitting}
              onClick={handleSubmit(confirm)}
              disabled={submitting}
            >
              Submit & Confirm
            </Button>,
          ]
        ) : (
          <Button  primary onClick={onPrint}>Print</Button>
        )}

        <Button onClick={onClose} disabled={submitting} secondary>
          Close
        </Button>
      </div>
    </form>
  );
};

AxaHdf.propTypes = {
  employeeParticulars: PropTypes.object,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  confirm: PropTypes.func,
  axaForm: PropTypes.object,
  hdfId: PropTypes.string,
  isReadOnly: PropTypes.bool,
  renderValue: PropTypes.func,
  onSave: PropTypes.func,
  onPrint: PropTypes.func,
  onClose: PropTypes.func,
};

export default compose(
  enhance,
  reduxForm({
    form: AXA_HDF_ID,
    enableReinitialize: true,
    validate: validateForm,
  })
)(AxaHdf);



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Axa/form.js